// extracted by mini-css-extract-plugin
export default {"userpic":"lsf-userpic","userpic__username":"lsf-userpic__username","waiting":"lsf-waiting"};